<!-- header.component.html -->
<div *ngIf="!networkStatus" class="fixed top-0 w-full bg-red text-white text-center z-50  py-1">
  Please check network you are offline
</div>
<header [class.mt-[20px]]="!networkStatus" [class.mt-[32px]]="updateBarVisible"
  class="flex-none w-full h-[56px] bg-light-grey shadow-[0px_0px_15px_0px_#0000001F] z-10">
  <div class=" flex items-center w-full py-3 px-[60px]">
    <div class="w-full flex items-center">
      <!-- Logo -->
      <!--
        `isSSO && mainLabUrl` = CST-style scoped-kiosk session: no home link,
        no clickable logo. Full SSO logins (mainLabUrl null) render the
        regular clickable logo and standard header just like local logins.
      -->
      <div class="w-[180px]" [class.cursor-pointer]="!isSSO || !mainLabUrl">
        <a *ngIf="!isSSO || !mainLabUrl; else ssoLogo" [routerLink]="ability.defaultPage()" class="block h-full">
          <img [src]="'/assets/images/logo.svg'" alt="Dormotech Logo" class="w-[140px] h-[30px]" height="23"
            width="126" />
        </a>
        <ng-template #ssoLogo>
          <img [src]="'/assets/images/logo.svg'" alt="Dormotech Logo" class="w-[140px] h-[30px]" height="23"
            width="126" />
        </ng-template>
      </div>

      <!-- Test Info -->
      <app-test-info *ngIf="(!isSSO || !mainLabUrl) && currTest?.id" [currTest]="currTest" [patientDetails]="patientDetails"
        [isBigScreen$]="isBigScreen$">
      </app-test-info>

      <!-- SSO: Back to main lab -->
      <div *ngIf="isSSO && mainLabUrl" class="flex items-center ml-auto">
        <button mat-flat-button color="primary" class="btn-md" (click)="goBackToMainLab()">
          <mat-icon class="text-white">arrow_back</mat-icon>
          Back to main lab
        </button>
      </div>

      <!-- Main Navigation Area -->
      <div *ngIf="!isSSO || !mainLabUrl" class="flex items-center ml-auto">
        <!-- Left Side: Search & Actions -->
        <div class="flex items-center gap-4">
          <ng-container *ngIf="!currTest?.id && !isSharedPhysician">
            <label class="search-label" *ngIf="ability.canCreate(ability.subjects.TestRecord)"> Open Test
              for an Existing Patient </label>
            <!-- Search Bar -->
            <mat-form-field *ngIf="ability.canCreate(ability.subjects.TestRecord)" appearance="outline"
              class="search-field flex-1" subscriptSizing="dynamic">
              <mat-icon matSuffix class="text-primary-text">search</mat-icon>
              <input [formControl]="searchControl" [matAutocomplete]="auto" matInput class="primary text-md"
                placeholder="Search Patient" />

              <mat-autocomplete (optionSelected)="onPatientSelected($event.option.value)" #auto="matAutocomplete"
                class="patient-autocomplete">
                <mat-option *ngFor="let patient of filteredPatients$ | async" [value]="patient">
                  <div class="flex flex-col">
                    <span> Name:{{ patient.user.firstName }} {{ patient.user.lastName }} </span>
                    <span> Patient ID:{{ patient.patientId}} </span>
                  </div>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <!-- New Patient Button -->
            <button *ngIf="ability.canView(ability.subjects.PatientsPage)"
              [disabled]="!ability.canCreate(ability.subjects.Patient)" mat-flat-button color="primary" class="btn-md"
              (click)="openNewPatientDialog()">
              <mat-icon class="text-white">add</mat-icon>
              New Patient
            </button>

            <!-- Live Tests Counter -->
            <button *ngIf="ability.canView(ability.subjects.LiveTestsPage)" mat-stroked-button
              (click)="router.navigateByUrl('/live-tests')" class="btn-md">
              Live Tests: {{ liveTestsNum }}
              <mat-icon>chevron_right</mat-icon>
            </button>
          </ng-container>

          <!-- Right Side: User Menu -->
          <div class="flex items-center gap-3">
            <!-- Monitoring Mode Badge -->
            <div *ngIf="sessionService.isInMonitorMode$ | async"
              class="flex items-center gap-2 px-3 py-1 bg-yellow-100 border border-yellow-300 rounded-full">
              <span class="text-yellow-700 font-semibold text-sm flex items-center gap-1">
                <mat-icon class="text-sm" style="font-size: 16px; height: 16px; width: 16px;">lock</mat-icon>
                Monitor Mode
              </span>
            </div>

            <div class="profile-icon">
              <mat-icon [matMenuTriggerFor]="menu" [matTooltip]="getSalutation()" class="sidebar-icon cursor-pointer"
                fontSet="material-symbols-outlined">account_circle</mat-icon>
              <span class="notification-count" *ngIf="!isSharedPhysician && notificationStore?.notifications?.items?.length">
                {{
                notificationStore?.notifications?.meta.totalItems > 99
                ? "99+"
                : notificationStore?.notifications?.meta.totalItems
                }}
              </span>
            </div>

            <mat-menu #menu="matMenu">
              <button *ngIf="!isSharedPhysician" mat-menu-item (click)="notifications()">
                <span>Notifications</span>
              </button>
              <a *ngIf="!isSharedPhysician" mat-menu-item target="_blank" href="/assets/pdf/DormoTech-Manual.pdf">
                <span>User Manual</span>
              </a>
              <button *ngIf="!isSharedPhysician || ability.isMainLab" mat-menu-item (click)="openProfileDialog()">
                <span>Profile Settings</span>
              </button>
              <button mat-menu-item (click)="logout()">
                <span>Logout</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>

      <!-- Offline Message -->
    </div>
  </div>
</header>
